import { createSelector } from 'reselect'

const quiz_save_selector = createSelector(
	[ state => state.quiz ],
	quizState => ({
		entityUID: quizState.entityUID,
		allQuestionsDone: quizState.questions.filter(question => question.status === 'saving' || question.status === 'deleting').length===0,
		allIconsDone: quizState.questions.filter(question => question.icon.status === 'uploading').length===0,
		instructionsValue: quizState.title.text,
		timerValue: quizState.timer.value,
	})
)

export default quiz_save_selector
